// client/src/firebase.config.js
// Firebase web app config is driven by REACT_APP_FIREBASE_* env vars
// (see client/.env.development and client/.env.production).
// Falls back to the production project (lottologic-e2dee) when unset,
// so existing production builds behave identically.
export const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyDxZbOnFGh3iWr1r994lb39nuqs68iuaT0",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "lottologic-e2dee.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "lottologic-e2dee",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "lottologic-e2dee.appspot.com",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "72178540446",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:72178540446:web:0c99b9e271cf8a01cdc08f",
};
